import React from "react";

export default function ({t, errors, isErrorInChildren}) {
    return (
        <div className={"map-drawer-alerts"}
             aria-label={t("shadowDescription.CL_SK3.configuration.alarms._title")}>
            {
                !errors.isEmpty() &&
                <ul className={"helper-tutorial"}>
                    {
                        errors.groupByType().map(({key, name, alerts}) => (
                            <React.Fragment key={key}>
                                <li className={"header"}>
                                    {name}
                                </li>
                                {
                                    alerts.map((alert, i) => (
                                        <li
                                            key={`${key}_${i}`}>{alert.getTranslated()}
                                            {
                                                (alert.getCounter() > 1) &&
                                                <small>
                                                    {`x ${alert.getCounterByType(key)}`}
                                                </small>
                                            }
                                        </li>
                                    ))
                                }
                            </React.Fragment>
                        ))
                    }
                </ul>
            }
            {
                !!isErrorInChildren &&
                <div>
                    {t("newSettings.buildings.farmMap.clickToShowAlert")}
                </div>
            }
        </div>
    )
}
